import { Menu, MenuProps, Select } from 'antd';
import { AuctionState, auctionStateDescription } from 'models/auction/Auction';
import ExplainedLabel from 'pages/common/components/ExplainedLabel';
import { memo } from 'react';

import styles from './AuctionListMenu.module.css';

interface AuctionListMenuProps {
  activeAuctionMenu: AuctionState;
  setActiveAuctionMenu: (auctionState: AuctionState) => void;
  isMobileView: boolean;
}

function AuctionListMenu({ activeAuctionMenu, setActiveAuctionMenu, isMobileView }: AuctionListMenuProps) {
  const auctionMenus = [
    {
      label: (
        <ExplainedLabel
          label={auctionStateDescription.draft.name}
          explanation={auctionStateDescription.draft.description}
          placement="right"
          isMobileView={isMobileView}
        />
      ),
      key: 'draft' as AuctionState,
      value: 'draft' as AuctionState,
    },
    {
      label: (
        <ExplainedLabel
          label={auctionStateDescription.active.name}
          explanation={auctionStateDescription.active.description}
          placement="right"
          isMobileView={isMobileView}
        />
      ),
      key: 'active' as AuctionState,
      value: 'active' as AuctionState,
    },
    {
      label: (
        <ExplainedLabel
          label={auctionStateDescription.sold.name}
          explanation={auctionStateDescription.sold.description}
          placement="right"
          isMobileView={isMobileView}
        />
      ),
      key: 'sold' as AuctionState,
      value: 'sold' as AuctionState,
    },
    {
      label: (
        <ExplainedLabel
          label={auctionStateDescription.unsold.name}
          explanation={auctionStateDescription.unsold.description}
          placement="right"
          isMobileView={isMobileView}
        />
      ),
      key: 'unsold' as AuctionState,
      value: 'unsold' as AuctionState,
    },
    {
      label: (
        <ExplainedLabel
          label={auctionStateDescription.canceled.name}
          explanation={auctionStateDescription.canceled.description}
          placement="right"
          isMobileView={isMobileView}
        />
      ),
      key: 'canceled' as AuctionState,
      value: 'canceled' as AuctionState,
    },
    {
      label: (
        <ExplainedLabel
          label={auctionStateDescription.suspended.name}
          explanation={auctionStateDescription.suspended.description}
          placement="right"
          isMobileView={isMobileView}
        />
      ),
      key: 'suspended' as AuctionState,
      value: 'suspended' as AuctionState,
    },
  ];

  const onClickAuctionMenu: MenuProps['onClick'] = (e) => {
    setActiveAuctionMenu(e.key as AuctionState);
  };

  return isMobileView ? (
    <Select
      className={styles.select}
      popupClassName={styles['select-dropdown']}
      value={activeAuctionMenu}
      onChange={setActiveAuctionMenu}
      options={auctionMenus}
    />
  ) : (
    <Menu onClick={onClickAuctionMenu} selectedKeys={[activeAuctionMenu]} mode="vertical" items={auctionMenus} />
  );
}

export default memo(AuctionListMenu);
